export const REQUEST_HOSPITAL_LIST = "hospital/REQUEST_HOSPITAL_LIST";

export const HOSPITAL_LIST_IS_LOADING = "hospital/HOSPITAL_LIST_IS_LOADING";

export const REQUEST_HOSPITAL_LIST_SUCCESS =
  "hospital/REQUEST_HOSPITAL_LIST_SUCCESS";
export const REQUEST_HOSPITAL_LIST_FAIL = "hospital/REQUEST_HOSPITAL_LIST_FAIL";

export const SELECT_HOSPITAL_BY_ID = "hospital/SELECT_HOSPITAL_BY_ID";

export const RESET_SELECTED_HOSPITAL = "hospital/RESET_SELECTED_HOSPITAL";

export const REQUEST_HOSPITAL_LIST_BY_FEATURE_ID = `hospital/REQUEST_HOSPITAL_LIST_BY_FEATURE_ID`;
export const HOSPITAL_LIST_BY_FEATURE_ID_IS_LOADING = `hospital/HOSPITAL_LIST_BY_FEATURE_ID_IS_LOADING`;
export const REQUEST_HOSPITAL_LIST_BY_FEATURE_ID_SUCCESS = `hospital/REQUEST_HOSPITAL_LIST_BY_FEATURE_ID_SUCCESS`;
export const REQUEST_HOSPITAL_LIST_BY_FEATURE_ID_FAIL = `hospital/REQUEST_HOSPITAL_LIST_BY_FEATURE_ID_FAIL`;
export const SET_SEARCH_PATTERN_HOSPITAL = "SET_SEARCH_PATTERN_HOSPITAL";

export const REQUEST_FEATURE_LIST_BY_HOSPITAL_ID =
  "hospital/REQUEST_FEATURE_LIST_BY_HOSPITAL_ID";
export const REQUEST_FEATURE_LIST_BY_HOSPITAL_ID_SUCCESS =
  "hospital/REQUEST_FEATURE_LIST_BY_HOSPITAL_ID_SUCCESS";
export const REQUEST_FEATURE_LIST_BY_HOSPITAL_ID_FAIL =
  "hospital/REQUEST_FEATURE_LIST_BY_HOSPITAL_ID_FAIL";
export const RESET_FEATURE_LIST_BY_HOSPITAL =
  "hospital/RESET_FEATURE_LIST_BY_HOSPITAL";

export const SWITCH_SELECT_FLOW = "hospital/SWITCH_SELECT_FLOW";
